// extracted by mini-css-extract-plugin
module.exports = {"Vl":"ToolbarSeparator_Vl__2-2TH"};